/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banners_Inbox_Close_LabelInputs */

const de_banners_inbox_close_label = /** @type {(inputs: Banners_Inbox_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/** @type {(inputs: Banners_Inbox_Close_LabelInputs) => LocalizedString} */
const en_banners_inbox_close_label = de_banners_inbox_close_label;

/**

* @param {Banners_Inbox_Close_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const banners_inbox_close_label = /** @type {((inputs?: Banners_Inbox_Close_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banners_Inbox_Close_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_banners_inbox_close_label(inputs)
	return en_banners_inbox_close_label(inputs)
});